export default "__VITE_ASSET__a8e9fdb9__"